<template>
	<div class="content-wrapper">
		<div class="impersonation-message" v-if="isImpersonated">
			<FallBack iconStyle="far" icon="bell" :message="impersonationMessage" />
		</div>
		<iframe
			v-if="!isImpersonated && analyticsUrl"
			ref="analytics"
			class="social-analytics embed"
			id="vendasta-analytics"
			:src="analyticsUrl"
			title="Social Analytics"
		></iframe>
		<div
			class="social-analytics-loading"
			v-if="!isImpersonated && !analyticsUrl && !error"
		>
			<LoadingIcon />
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import FallBack from '../../components/global/FallBack.vue';
import LoadingIcon from '../../components/global/LoadingIcon.vue';
import socialMarketingService from '../../services/toolbox/social-marketing-service';
import { ERROR_DETAILS } from '../../constants/error-details';

export default {
	name: 'SocialMediaAnalytics',
	components: {
		FallBack,
		LoadingIcon,
		socialMarketingService,
	},
	data() {
		return {
			analyticsUrl: null,
			error: false,
		};
	},
	computed: {
		...mapState({
			rolodexContactId: (state) => state.profile.rolodexContactId,
		}),
		...mapGetters(['isImpersonated']),
		impersonationMessage() {
			return `You cannot view Social Analytics while impersonating another user.`;
		},
	},
	methods: {
		...mapActions(['showErrorModal']),
		async getAnalyticsUrl() {
			this.error = false;
			if (!this.isImpersonated) {
				try {
					const { data } = await socialMarketingService.getAnalyticsUrl();
					this.analyticsUrl = data;
				} catch (error) {
					this.error = true;
					this.showErrorModal({
						error,
						errorDetails: ERROR_DETAILS.GET_ANALYTICS_URL,
					});
				}
			}
		},
	},
	mounted() {
		this.getAnalyticsUrl();
	},
	watch: {
		rolodexContactId() {
			this.getAnalyticsUrl();
		},
	},
};
</script>

<style lang="scss" scoped>
.content-wrapper {
	width: 100%;
	height: calc(100vh - 185px + #{$context-nav-height});
	margin: -$context-nav-height 0 0 0;
}

.impersonation-message {
	@include rem('padding', 40px);
}

.social-analytics {
	border: none;
	margin: 0;
	width: 100%;
	height: 100%;
}

.social-analytics-loading {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
}
</style>
